<template>
  <div class="super-visa">
    <h1>父母超级签证Super Visa</h1>
    <div class="subtitle">访问签证</div>
    
    <div class="content-section">
      <p>超级签证是签发给加拿大公民或永久居民的父母或祖父母的一种长达10年的多次往返签证，该签证每次可以在加拿大停留2年的一种长期访问签证。申请人必须要在加拿大境外申请。</p>
      
      <h2>政策最新更新</h2>
      <ul>
        <li>如果是在2023年5月22日或之后申请的：在加拿大永久居民或公民的邀请下，利用超级签证可以停留2年。</li>
        <li>如果是在2023年5月22日之前申请的：到审查
          <ul>
            <li>在加拿大期间的医疗保险有效期持续有效</li>
            <li>确保在加拿大期间的护照有效</li>
          </ul>
        </li>
      </ul>

      <h2>申请超级签证的资格</h2>
      <p>要获得超级签证，申请人必须满一定条件。邀请人需满足以下条件：</p>
      <ul>
        <li>是申请人的儿子女儿或孙子孙女</li>
        <li>是加拿大公民、加拿大永久居民或注册印第安人</li>
        <li>年满18岁并在加拿大</li>
        <li>达到规定的最低收入要求
          <ul>
            <li>一封邀请申请人来加拿大的函</li>
            <li>承诺在申请人在加期间提供经济支持</li>
          </ul>
        </li>
        <li>永远在加拿大期间提供经济支持</li>
      </ul>

      <h2>此外，申请人需满足以下条件：</h2>
      <ul>
        <li>当前父母超级签证申请时不在加拿大境内</li>
        <li>由加拿大移民局承认的签证处签发超级签证</li>
        <li>准许进入加拿大</li>
        <li>参加移民体检</li>
        <li>满足其它要求（如访问目标、家庭关系等）</li>
      </ul>

      <h2>健康保险</h2>
      <p>申请人必须购买以下任一一种健康保险：</p>
      <ul>
        <li>国泰大药房公司</li>
        <li>IRCC推进的保险公司</li>
      </ul>

      <h2>健康保险必须满足：</h2>
      <ul>
        <li>自入境之日起，有效期至少为 1 年</li>
        <li>全额或分期付付</li>
        <li>包括住院保险、生病及返回原居住国费用</li>
        <li>保额至少 10万加币的紧急医疗保险</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuperVisaView'
}
</script>

<style scoped lang="less">
.super-visa {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;

  h1 {
    font-size: 32px;
    color: #333;
    margin-bottom: 10px;
  }

  .subtitle {
    font-size: 18px;
    color: #666;
    margin-bottom: 30px;
  }

  .content-section {
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    p {
      font-size: 16px;
      line-height: 1.6;
      color: #444;
      margin-bottom: 25px;
    }

    h2 {
      font-size: 24px;
      color: #333;
      margin: 30px 0 20px;
      padding-bottom: 10px;
      border-bottom: 2px solid #f0f0f0;
    }

    ul {
      list-style: none;
      padding: 0;
      margin-bottom: 20px;

      li {
        font-size: 16px;
        color: #555;
        margin-bottom: 12px;
        padding-left: 20px;
        position: relative;

        &:before {
          content: "•";
          color: #409EFF;
          position: absolute;
          left: 0;
        }

        ul {
          margin: 10px 0 10px 20px;
        }
      }
    }
  }
}
</style>